<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" icon="fas fa-pen-nib" title="Sửa thông tin thư mục" />
    <el-form v-if="tag" ref="formPlagiarism" label-width="150px" label-position="right">
      <el-form-item label="Tên thư mục">
        <el-input placeholder="Tên thư mục" v-model="tag.name"></el-input>
      </el-form-item>
      <el-form-item label="Mô tả">
        <el-input type="textarea" :rows="2" placeholder="Mô tả" v-model="tag.description"> </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="closeModal">Hủy bỏ</el-button>
      <CommonButton :ref="refs.CONFIRM_BUTTON" type="primary" @click="onSubmitEditFolderForm">
        Cập nhập thư mục
      </CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import { apiUpdateTag } from "@/services/tag_management_service"
import FAIcon from "@/components/common/FAIcon.vue"
import ModalHeader from "@/components/common/ModalHeader.vue"
import _ from "lodash"
import CommonButton from '@/components/common/CommonButton.vue'

export default {
  name: "TagEditModal",
  components: {CommonButton, ModalHeader, FAIcon },
  data: function () {
    return {
      show: false,
      tag: null,
      refs: {
        CONFIRM_BUTTON: "confirmButton",
      },
    }
  },
  methods: {
    openModal(tag) {
      this.show = true
      this.tag = _.cloneDeep(tag)
    },
    async onSubmitEditFolderForm() {
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(true)
      let res = await apiUpdateTag(this.tag.id, {
        name: this.tag.name,
        description: this.tag.description,
      })
      if (res != null) {
        this.$message.success("Cập nhật thành công")
        this.$emit("success")
        this.show = false
      } else {
        this.$message.error("Có lỗi xảy ra")
      }
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(false)
    },
    closeModal() {
      this.show = false
    },
  },
}
</script>
